import { api } from '@api'
import type { InsertTakenSetups } from '@hvf/contracts'

export const handleGetSetup = async (id: string) => {
  const { data } = await api().from('setup').select('*').eq('id', id).maybeSingle()
  return data
}

export const handleGetSetupTaken = async (id?: string, userId?: string) => {
  if (!userId || !id) {
    return null
  }

  const { data } = await api()
    .from('taken_setups')
    .select('*')
    .eq('setup_id', id)
    .eq('user_id', userId)
    .maybeSingle()

  return data
}

export const toggleSetupTaken = async (takenSetup: InsertTakenSetups) => {
  if (!takenSetup.user_id || !takenSetup.setup_id) return null

  const { data, error } = await api()
    .from('taken_setups')
    .upsert(takenSetup, { onConflict: 'user_id,setup_id' })
    .select()

  if (error) throw error

  return data
}

export const getSetupPotentialHigQuality = async (id: string) => {
  const { data, error } = await api()
    .from('potential_high_quality')
    .select('*')
    .eq('setup_id', id)
    .neq('status', 'rejected')
    .maybeSingle()

  if (error) throw error

  return data
}

export const getSetupTakenCount = async (setupId: string) => {
  const { count, error } = await api()
    .from('taken_setups')
    .select('*', { count: 'exact', head: true })
    .eq('setup_id', setupId)
    .eq('has_taken', true)

  if (error) throw error
  return count || 0
}

export const getSetupSubscribedCount = async (channelId: string) => {
  const { count, error } = await api()
    .from('channel_reads')
    .select('*', { count: 'exact', head: true })
    .eq('channel_id', channelId)
    .eq('is_subscribed', true)

  if (error) throw error
  return count || 0
}
